/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * agora/v1/workspace.proto
 * OpenAPI spec version: version not set
 */

/**
 * The category/type of a workspace, used to tailor workspace behavior.

Deliberately kept in its own file with no imports. `WorkspaceType` is needed
by both `types.proto` (on `Workspace`) and `rbac.proto` (on `RoleTemplate`),
and `types.proto` already imports `rbac.proto` for `RoleScope` — so defining
it in either of those files makes the other's import cyclic.

 - WORKSPACE_TYPE_UNSPECIFIED: Not set. Not a workspace category in its own right: a workspace created
without an explicit type is treated as WORKSPACE_TYPE_REGULAR, and this
value is not a valid member of `RoleTemplate.workspace_types`.
 - WORKSPACE_TYPE_FINANCE: Finance workspace.
 - WORKSPACE_TYPE_REGULAR: Regular (general-purpose, automation-oriented) workspace — the default
for workspaces created without an explicit type.

Numbered after FINANCE only because renumbering an existing value is a
wire break; REGULAR is the baseline kind, not a later addition.
 */
export type V1WorkspaceType =
  (typeof V1WorkspaceType)[keyof typeof V1WorkspaceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1WorkspaceType = {
  WORKSPACE_TYPE_UNSPECIFIED: 'WORKSPACE_TYPE_UNSPECIFIED',
  WORKSPACE_TYPE_FINANCE: 'WORKSPACE_TYPE_FINANCE',
  WORKSPACE_TYPE_REGULAR: 'WORKSPACE_TYPE_REGULAR',
} as const;
